import React from 'react'
import { ColumnRank, ColumnStartOrder, ColumnBib, ColumnName,  ColumnNoc,  ColumnWarnings, ColumnExpander, ColumnResult, ColumnQualification as ColumnQualificationGlobal } from "components/common/TableColumns"
import { ColumnPty } from "../common/TableColumns";
import Label from 'components/general/Label';
import SportCode from 'components/common/SportCode';
import { appealIcon, waringIcon } from '../common/Icons';

export function ColumnRankRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Rank',
        headerClassName: "text-end w-5 text-nowrap align-middle",
        id: 'HeaderRank',
        columns: [
            ColumnRank({remove: true})
        ]
      }
}

export function ColumnStartOrderRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'StartOrder',
        headerClassName: "text-end w-5 text-nowrap align-middle",
        id: 'HeaderStartOrder',
        columns: [
            ColumnStartOrder({remove: true})
        ]
      }
}

export function ColumnBibRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Bib',
        headerClassName: "text-end w-5 text-nowrap align-middle",
        id: 'HeaderBib',
        columns: [
            ColumnBib({label: "HeaderBibNoR", remove: true})
        ]
      }
}

export function ColumnNocRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'NOC',
        headerClassName: "text-start d-none d-md-table-cell w-5 align-middle",
        id: 'HeaderNOC',
        columns: [
            ColumnNoc({remove: true})
        ]
      }
}

export function ColumnNameRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Name',
        headerClassName: "text-start align-middle",
        id: 'HeaderName',
        columns: [
            ColumnName({remove: true})
        ]
      }
}

export function ColumnWarningsRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Warnings',
        headerClassName: "text-end w-10 align-middle",
        id: 'HeaderWarnings',
        columns: [
            ColumnWarnings({remove: true})
        ]
      }
}

export function ColumnResultRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Result',
        headerClassName: "text-center expander w-5 align-middle",
        id: 'HeaderResult',
        columns: [
            ColumnResult({remove: true, label : "HeaderAwaredPoints"})
        ]
      }
}

export function ColumnQualificationRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'QualMark',
        className: 'text-end',
        headerClassName: 'text-end w-5 align-middle',
        id: 'HeaderQualMark',
        columns: [
            ColumnQualificationGlobal({remove: true})
        ]
      }
}



export function ColumnExpanderRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Expander',
        headerClassName: "text-center expander w-5 align-middle",
        id: 'HeaderExpander',
        columns: [
            ColumnExpander({remove: true})
        ]
      }
}

export function ColumnBouldersColSpan({boulders = []}){
    return {
        id: 'HeaderBoulders',
        Header: <Label data="HeaderBoulder" />,
        headerClassName: "text-center",
        columns: [ ...getColumnBoulder(boulders)]
    }

}

function getColumnBoulder(boulders){
    return boulders?.map(b => (
            {
                id: 'Boulder' + b?.pos,
                Header: b?.value,
                headerClassName: "text-center",
                className: 'text-center w-5',
                Cell: (props) => {
                    const res = props.cell.row.original;
                    let value = res?.extendedResults?.find(er => er?.er_code === 'RESULT' && er?.er_type === 'BOULDER' && er?.er_pos === b?.pos)?.er_value;
                    return value;
                }
            }
        ))
}

export function ColumnResultBoulder({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderBoulderPoints',
    remove = false,
    boulderResults
    }) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => {
                let res =  boulderResults?.find(item => item?.participant?.code === props?.participant?.code);
                return res?.sortOrder;
            },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'ResultBulder',
            remove: remove,

            Cell: (props) => {
                let res = boulderResults?.find(item => item?.participant?.code === props.cell.row.original?.participant?.code)
                if (!res) return '';
                let irmObject = <SportCode discipline='CLB' entity='@IRM' code={res?.resultIrm} abbr={true} />
                return (
                    res?.resultType === 'IRM'
                        ? irmObject
                        : res?.resultData && res?.resultRank  ? `${res.resultData} (${res.resultRank})` : res?.resultData
                )
            },
        }
    )
}

export function ColumnResultLead({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderLeadPoints',
    remove = false
    }) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'Result',
            remove: remove,
            Cell: (props) => {
                let res = props.cell.row.original
                let irmObject = <SportCode discipline='CLB' entity='@IRM' code={res?.resultIrm} abbr={true} />
                const revision = res?.unchecked ? appealIcon : '';
               return (
                    res?.resultType === 'IRM'
                        ? <>{revision}{irmObject}</>
                        : res?.resultData && res?.resultRank
                                    ? <>{revision}{`${res.resultData} (${res.resultRank})`}</>
                                    : <>{revision}{res.resultData}</>
                )
            },
        }
    )
}


export function ColumnResultTotal({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTotalPoints',
    remove = false,
    totalResults
    }) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => {
                let res =  totalResults?.find(item => item?.participant?.code === props?.participant?.code);
                return res?.sortOrder;
            },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort, //habilita poder ordenar
            id: 'ResultTotal',
            remove: remove,

            Cell: (props) => {
                let res = totalResults?.find(item => item.participant.code === props.cell.row.original?.participant?.code)
                if (!res) return '';
                if (res?.resultType === 'IRM') return (<SportCode discipline='CLB' entity='@IRM' code={res?.resultIrm} abbr={true} />);
                let hasResult  = res?.items?.find(item => item?.order === 2)?.resType;
                if (!hasResult) return '';
                return res?.resultData;
            }
        }
    )
}

export function ColumnRankTotal({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderRank',
    remove = false,
    totalResults
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => {
                let res =  totalResults?.find(item => item?.participant?.code === props?.participant?.code);
                return res?.sortOrder;
            },
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Rank',
            remove: remove,
            Cell: (props) => {
                let res = totalResults?.find(item => item.participant.code === props.cell.row.original?.participant?.code)
                if (!res) return '';
                if (res?.resultType === 'IRM') return '';
                let hasResult  = res?.items?.find(item => item?.order === 2)?.resType;
                if (!hasResult) return '';
                return res?.resultRank ? res?.resultRank : '';
    
            }
        }
    )
}

export function ColumnQualification({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    remove = false,
    totalResults
}) {
    return (
        {
            remove: remove,
            accessor: 'qualificationMark',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'QualMark',
            Cell: (props) => {
                let res = totalResults?.find(item => item.participant.code === props.cell.row.original?.participant?.code)
                if (!res) return '';
                return res?.qualificationMark ? res?.qualificationMark : '';
   
            }
        }
    )
}

export function ColumnPtyTotal({
    disableSort = true,
    className = 'text-start',
    headerClassName = 'text-start w-5',
    label = '',
    accessor = 'pty',
    totalResults = []
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'PtyTotal',
            Cell: (props) => {
                let res = totalResults?.find(item => item.participant.code === props.cell.row.original?.participant?.code)
                if (!res) return '';
                return res?.pty ? waringIcon : ''
            }
        }
    )
}

export function ColumnPtyRowSpan() {
    return {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'Pty',
        headerClassName: "text-start w-5 align-middle",
        id: 'HeaderPty',
        columns: [
            ColumnPty({remove: true})
        ]
      }
}
